import {useParams} from "react-router";
import {getVendor} from "../../api/Api";
import {useState, useEffect} from 'react';
import {VendorProfile} from './VendorProfile';

export const VendorView = ({onApiFail, refresh, onRefresh,  props}) => {
    const [vendor, setVendor] = useState(undefined);
    const params = useParams();
    const vendorId = params.vendorId;


    useEffect(() => {
        if (vendorId === undefined) {
            return;
        }
        getVendor(vendorId).then(result => {
            setVendor(result);

        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [vendorId, refresh, onApiFail]);

    if (!vendorId) {
        return <div />
    }

    return <VendorProfile vendor={vendor} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
}